export default __webpack_public_path__ + "static/media/folder.bd52825f.png";